var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_c('v-pagination',{attrs:{"value":_vm.page,"length":_vm.totalPage,"total-visible":20},on:{"input":_vm.changePage}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }